import React from "react";
import styles from './MessengersCheckbox.module.scss'
import CheckBoxInput from "../Inputs/CheckBoxInput/CheckBoxInput";
import { Lang } from "../../types/common-types";
import AccountForm from "../../types/account-form.types";
import { actions, Dispatch, State } from "../../state-actions-reducers";

interface MessengersCheckboxProps {
    lang: Lang
    accountForm: AccountForm
    state: State
    dispatch: Dispatch
    phoneNumber: string
}
export default function MessengersCheckbox({lang, accountForm, state, dispatch, phoneNumber}: MessengersCheckboxProps) {
    return <div className={styles.messengersCheckBox}>
    <span>{accountForm.contactsMessengersTitle[lang]}</span>
    <div className={styles.messengersCheck}>
      <CheckBoxInput
        testId={'telegramCheck'}
        name={'telegramCheck'}
        label={accountForm.telegramCheck}
        lang={lang}
        onChange={() => {
          dispatch({
            type: actions.TELEGRAM_CHECK,
            data: !state.telegramCheck
          });
          !state.telegramCheck ?
            dispatch({
              type: actions.MESSENGERS,
              data: state.messengers.find((e) => { return e.type === 'Telegram' && e.isCheck })
                ? state.messengers.map((item) => {
                  return (item.type === 'Telegram' && item.isCheck) ? {
                    type: "Telegram",
                    description: "Telegram",
                    link: `https://t.me/+${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                    isCheck: true
                  } : item
                }) : state.messengers.concat(
                  {
                    type: "Telegram",
                    description: "Telegram",
                    link: `https://t.me/+${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                    isCheck: true
                  },
                ),
            })
            : dispatch({
              type: actions.MESSENGERS,
              data: state.messengers.filter((item) => {
                return !(item.type === "Telegram" && item.isCheck)
              }),
            })
        }}
        valid={true}
        value={state.telegramCheck}
      />
      <CheckBoxInput
        testId={'whatsappCheck'}
        name={'whatsappCheck'}
        label={accountForm.whatsappCheck}
        lang={lang}
        onChange={() => {
          dispatch({
            type: actions.WHATSAPP_CHECK,
            data: !state.whatsappCheck
          });
          !state.whatsappCheck ?
            dispatch({
              type: actions.MESSENGERS,
              data: state.messengers.find((e) => { return e.type === 'WhatsApp' && e.isCheck })
                ? state.messengers.map((item) => {
                  return (item.type === 'WhatsApp' && item.isCheck) ? {
                    type: "WhatsApp",
                    description: "WhatsApp",
                    link: `https://wa.me/${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                    isCheck: true
                  } : item
                }) : state.messengers.concat(
                  {
                    type: "WhatsApp",
                    description: "WhatsApp",
                    link: `https://wa.me/${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                    isCheck: true
                  },
                ),
            })
            : dispatch({
              type: actions.MESSENGERS,
              data: state.messengers.filter((item) => {
                return !(item.type === "WhatsApp" && item.isCheck)
              }),
            })
        }}
        value={state.whatsappCheck}
        valid={true}
      />
    </div>
  </div>
}